'use es6';

import { INVOICE_PROPERTIES } from 'reference-resolvers/constants/CacheKeys';
import { getInvoiceProperties, createGetInvoiceProperties } from 'reference-resolvers/api/PropertiesAPI';
import createSimpleCachedReferenceResolver from 'reference-resolvers/lib/createSimpleCachedReferenceResolver';
export const createInvoicePropertyReferenceResolver = options => createSimpleCachedReferenceResolver(Object.assign({
  cacheKey: INVOICE_PROPERTIES,
  createFetchData: createGetInvoiceProperties,
  fetchData: getInvoiceProperties
}, options));
export default createInvoicePropertyReferenceResolver();